import React from "react";
const SalesTables = ({ salesData, count }) => {
  return (
    <table style={{ width: "100%", borderCollapse: "collapse", fontFamily: "Karla" }}>
      <thead>
        <tr>
          <th style={{ width: "80%", textAlign: "left", fontSize: "18px", padding: "10px 0", fontWeight: 500 }}>Total Sales</th>
          <th style={{ width: "20%", textAlign: "right", fontSize: "18px", padding: "10px 0", fontWeight: 500 }}>{count}</th>
        </tr>
        <tr>
          <td colSpan="2" style={{ borderBottom: "1px solid #000" }}></td>
        </tr>
      </thead>
      <tbody>
        {salesData.length > 0 ? (
          salesData.map((item) => (
            <tr key={item.name} style={{ borderBottom: "1px solid #ddd" }}>
              <td style={{ width: "80%", padding: "10px 0", fontSize: "18px", fontWeight: 500 }}>{item[0]}</td>
              <td style={{ width: "20%", textAlign: "right", padding: "10px 0", fontSize: "18px", fontWeight: 500 }}>{item[1]} Pcs</td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="2" style={{ textAlign: "center", padding: "10px 0", fontSize: "14px", fontWeight: 500 }}>
              No sales data available.
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
};
export default SalesTables;
